import { ReactElement, useState } from 'react'
import { Modal } from 'components'
import { Box, Typography } from '@mui/material'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import * as sxStyles from './dialogs.style'

interface IUseRecalculateModalProps {
  wheatCodeId: number
  onConfirm(wheatCodeid: number): void
}

const useRecalculateModal = ({
  wheatCodeId,
  onConfirm,
}: IUseRecalculateModalProps): [ReactElement, VoidFunction] => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggleModal = () => setIsOpen(!isOpen)
  const handleConfirm = () => {
    onConfirm(wheatCodeId)
    setIsOpen(false)
  }

  return [
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Attention!"
      onConfirm={handleConfirm}
      onConfirmButtonText="Ok"
    >
      <Box sx={sxStyles.recalculateModalBoxWrapper}>
        <WarningRoundedIcon sx={sxStyles.recalculateModalWarningIcon} />
        <Typography sx={sxStyles.recalculateModalTitle}>
          Heads up! The target bin for this Wheat Code has changed.
        </Typography>
      </Box>

      <Typography sx={sxStyles.recalculateModalLongText}>
        By clicking OK, all selected bins will be updated to use the new target
        bin.
      </Typography>
    </Modal>,
    toggleModal,
  ]
}

export default useRecalculateModal
